import React from "react";

const AccountButton = (props) => {
  return (
    <nav className="navbar fixed-bottom">
      <div className="container">
        <div className="col-3">
          {props.walletAddress ? (
            props.truncateAddress(props.walletAddress)
          ) : (
            <button onClick={props.connectWallet}>Connect Wallet</button>
          )}
        </div>
      </div>
    </nav>
  );
};

export default AccountButton;
